import * as Yup from 'yup';
import messages from 'components/ChangePassewordModal/messages';
import { translate } from 'helpers/intl';

export default (props: any) =>
  Yup.object().shape({
    secretQuestion: Yup.string().required(
      translate({ ...messages.requiredField }, props),
    ),
    response: Yup.string().required(
      translate({ ...messages.requiredField }, props),
    ),
    password: Yup.string().required(
      translate({ ...messages.requiredField }, props),
    ),
  });
